import { Box, Flex, HStack, VStack } from '@chakra-ui/react'
import React, { FC, ReactNode } from 'react'

export const ListPageMobile: FC<{
  children?: never
  renderElement(displayName: string): ReactNode
}> = ({ renderElement }) => (
  <Box backgroundColor="neutral.10" w="100%">
    <VStack w="100%">
      <Flex alignItems="stretch" w="100%">
        <Flex flexDirection="column" p="20px" w="100%">
          <Flex
            alignItems="flex-end"
            justifyContent="space-between"
            mb="18px"
            w="100%"
          >
            <VStack alignItems="baseline">
              {renderElement('ListPage.Header')}
              {renderElement('ListPage.InformationPanel')}
            </VStack>
            <HStack>
              {renderElement('ListPage.SortPanel')}
              {renderElement('ListPage.FilterPanel')}
            </HStack>
          </Flex>

          {renderElement('ListPage.ContentPanel')}
          {renderElement('ListPage.Pagination')}
        </Flex>
      </Flex>
    </VStack>
  </Box>
)
